/** 文章状态 */
export var PostStatus;
(function (PostStatus) {
    /** 草稿 */
    PostStatus[PostStatus["Draft"] = 0] = "Draft";
    /** 已发布 */
    PostStatus[PostStatus["Published"] = 1] = "Published";
})(PostStatus || (PostStatus = {}));
function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function delay(timeout) {
    return new Promise((resolve) => {
        setTimeout(resolve, timeout ? timeout : randomInt(100, 1200));
    });
}
function ceateMockPosts() {
    const len = 200;
    return new Array(len).fill(0).map((_, index) => ({
        id: len - index,
        title: `post - ${len - index}`,
        content: 'abcdefghijklmnopqrstuvwxyz'.slice(randomInt(0, 8), randomInt(14, 25)),
        status: randomInt(0, 1),
        order: randomInt(1, 20),
        createdAt: Date.now(),
        updatedAt: Date.now(),
    }));
}
let allPosts = ceateMockPosts();
function log(msg, ...args) {
    console.log(`%c ${msg}`, 'background: #222; color: #bada55', ...args);
}
function logRequest(...args) {
    log('=================== Request => ', ...args);
}
function logResponse(...args) {
    log('=================== Response => ', ...args);
}
export async function getPosts(dto = {}) {
    const { page = 1, pageSize = 20, title, status, order } = dto;
    logRequest('getPosts', dto);
    await delay();
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    let filteredList = allPosts.concat();
    if (title) {
        filteredList = filteredList.filter((item) => item.title.includes(title));
    }
    if (status || status === 0) {
        filteredList = filteredList.filter((item) => item.status === status);
    }
    if (order || order === 0) {
        filteredList.sort((a, b) => order === 0 ? a.order - b.order : b.order - a.order);
    }
    const ret = {
        list: filteredList.slice(start, end),
        pagination: {
            total: filteredList.length,
            page,
            pageSize,
        },
    };
    logResponse('getPosts', ret);
    return ret;
}
export async function getPostById(id) {
    await delay();
    return allPosts.find((item) => item.id === id);
}
export async function deletePost(id) {
    logRequest('deletePost', id);
    await delay();
    allPosts = allPosts.filter((item) => item.id !== id);
    logResponse('deletePost');
}
export async function createPost(dto) {
    logResponse('createPost', dto);
    await delay();
    const id = allPosts[0].id + 1;
    allPosts.unshift(Object.assign(Object.assign({}, dto), { id, createdAt: Date.now(), updatedAt: Date.now() }));
    logResponse('createPost', allPosts);
    return { id };
}
export async function updatePost(dto) {
    logRequest('updatePost', dto);
    await delay();
    allPosts = allPosts.map((item) => {
        if (item.id === dto.id) {
            return Object.assign(Object.assign({}, item), JSON.parse(JSON.stringify(dto)));
        }
        return item;
    });
    logResponse('updatePost');
}
export async function batchUpdatePostsStatus(dto) {
    logRequest('batchUpdatePost', dto);
    await delay();
    const { ids, status } = dto;
    allPosts = allPosts.map((item) => {
        if (ids.includes(item.id)) {
            return Object.assign(Object.assign({}, item), { status });
        }
        return item;
    });
    logResponse('batchUpdatePost');
}